<div class="main-sunburst">
  <div id="centro-sunburst" class="centro-sunburst">
    <img src="assets/images/connections.svg" alt="">
  </div>
  <div id="container-conexoes"></div>
</div>
